import { SEND_APPROVAL_MAIL, SEND_APPROVAL_MAIL_SUCCESS, SEND_APPROVAL_MAIL_ERROR, SEND_APPROVAL_MAIL_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendApprovalMail = (state = initialState, action) => {
  switch (action.type) {
    case SEND_APPROVAL_MAIL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_APPROVAL_MAIL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_APPROVAL_MAIL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_APPROVAL_MAIL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendApprovalMail;
